<template>
  <div></div>
</template>
<script>
import $ from "jquery";
import ClientService from "../services/client.service";
export default {
  name: "SavedCardMixins",
  data() {
    return {
        cardsToShow: 4,
        savedCardTableBuilt: false,
        showCards: true,
        displayedSavedCards: [],
        mutableSavedCardsObject: this.originalSavedCards,
    };
  },
  props: {
    originalSavedCards: {
      type: Array,
      default: function() {
        return [];
      }
    },
    entryClientObject: {
      type: Object,
      default: function() {
        return {};
      }
    },    
    viewType: {
      type: String,
      default: "cards"
    },    
    setType: {
      type: String,
      default: ""
    },
  },
  computed: {
    isMenuView: function() {
      return this.viewType ==  "menu"
    },
    isDashboardView: function() {
      return this.viewType ==  "dashboard"
    },
    isSavedCardsSetForSurvey: function() {
      return this.setType == "survey";
    },
    isSavedCardsSetForOrganization: function() {
      return this.setType == "organization";
    }
  },
  methods: {
    getDisplayedSavedCards(){
      // check to see if this.mutableSavedCardsObject is an array
      if (typeof this.mutableSavedCardsObject == "undefined" || this.mutableSavedCardsObject == null ){
        return;
      }
      if (!Array.isArray(this.mutableSavedCardsObject)){
        return;
      }
      if (this.isDashboardView == true || this.isMenuView == true){
        let pinnedSavedCards = this.mutableSavedCardsObject.filter(savedCard => {return savedCard.pin == "Y";});
        let unpinnedSavedCards = this.mutableSavedCardsObject.filter(savedCard => {return savedCard.pin == "N";});
        this.displayedSavedCards = JSON.parse(JSON.stringify(pinnedSavedCards)); 
        this.displayedSavedCards.push(...JSON.parse(JSON.stringify(unpinnedSavedCards)));
        this.displayedSavedCards = this.displayedSavedCards.slice(0,this.cardsToShow);
      } else {
        this.displayedSavedCards = JSON.parse(JSON.stringify(this.mutableSavedCardsObject)); 
      }
    },
    resetClientCharts(result) {
      let match = this.entryClientObject.clientCharts.find(x => x.clientChartId == result);
      if (typeof match !== "undefined") {
        let localEntryClientObject = this.entryClientObject;
        localEntryClientObject.clientCharts.splice($.inArray(match, this.entryClientObject.clientCharts), 1);
        ClientService.saveClient(localEntryClientObject);
        this.$root.setClientObject(localEntryClientObject);
      }
    }
  },
  created() {},
  watch: {
    originalSavedCards: function() {
      this.mutableSavedCardsObject = this.originalSavedCards;
      this.savedCardTableBuilt = false;
      if (this.showCards == true) {
        this.buildSavedCardTable();
      }
    },
  },
  mounted() {}
};
</script>
